<template>
  <el-card style="max-width:1200px;margin: 50px auto;">
    <div class="title">订阅消息模板配置</div>
    <ele-form
      v-model="formData"
      :form-desc="formDesc"
      :request-fn="handleSubmit"
      :rules="rules"
      @request-success="handleSuccess"
    ></ele-form>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      // 表单数据
      formData: {},
      formDesc: {
        // 订阅消息预订成功 order_booking
        // 订阅消息出票失败 drawer_fail
        // 订阅消息退单成功 refund_success
        // 订阅消息入园提醒 near_note
        order_booking: {
          type: "input",
          label: "预订成功"
        },
        near_note: {
          type: "input",
          label: "入园提醒"
        },
        drawer_fail: {
          type: "input",
          label: "出票失败"
        },
        refund_success: {
          type: "input",
          label: "退单成功"
        }
      }
    };
  },
  methods: {
    handleSubmit(data) {
      // eslint-disable-next-line no-console
      console.log(data);
      return Promise.resolve();
    },
    handleSuccess() {
      this.$message.success("创建成功");
    }
  }
};
</script>

<style>
body {
  background-color: #efefef;
}
.title {
  font-size: 18px;
}
</style>
